// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body__22lRd","list":"styles_list__2BY0M"};